import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { RootState } from 'src/configs/store';
import Form from 'src/components/Form/Form';

interface ExistingCustomerProps {
  close: () => void
}

export default function ExistingCustomer({ close }: ExistingCustomerProps) {
  const { t } = useTranslation('common');
  const { customer } = useSelector((state: RootState) => state.auth);

  const steps = [
    {
      inputs: [
        {
          type: 'label',
          className: 'align-center',
          text: t('form.customerInfo', { name: customer.shortName, id: customer.id })
        }
      ],
      buttons: [
        {
          className: 'modal-submit',
          type: 'submit',
          label: t('form.ok')
        }
      ]
    }
  ];

  return (
    <Form
      containerClass="existing-customer-form"
      steps={ steps }
      close={ close }
    />
  );
}
